import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useLocalizedNavigate from 'hooks/useLocalizedNavigate';
import { mockTableGames } from 'mocks/games';
import { TableGamesIcon } from 'components/icons';
import styles from './tableGamesCarousel.module.scss';

const TableGamesCarousel: React.FC = () => {
  const { t } = useTranslation();
  const scrollRef = useRef<HTMLDivElement>(null);
  const navigate = useLocalizedNavigate();

  const handleSeeAll = () => {
    navigate('/casino/categories/table_games');
  };

  const handleGameClick = (route: string) => {
    navigate(route);
  };

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.header}>
        <div className={styles.title}>
          <span className={styles.titleIcon}>
            <TableGamesIcon width="20" height="20" style={{ color: 'var(--text-active)' }} />
          </span>
          {t('common.tableGames', 'Table Games')}
        </div>
        <div className={styles.navControls}>
          <button
            className={styles.seeAllBtn}
            aria-label={t('common.seeAllGames', 'See all games')}
            onClick={handleSeeAll}
          >
            {t('common.seeAll', 'See All')}
          </button>
        </div>
      </div>

      <div className={styles.track} ref={scrollRef}>
        {mockTableGames.map((game) => (
          <div key={game.id} className={styles.card} onClick={() => handleGameClick(game.route)}>
            <img src={game.image} alt={game.name} className={styles.cardImage} />
            <div className={styles.cardOverlay}>
              <span className={styles.cardTitle}>{game.name}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableGamesCarousel;
